export default {
    blog_text_1: "Our",
    blog_text_2: "blogs",
    blog_text_3: "Other articles",

    p_packages_text_1: "DOFFERO FUNCTIONS",
    p_packages_text_2: "What I will get",
    p_packages_text_3: "Unlimited offers",
    p_packages_text_4: "Unlimited number of clients",
    p_packages_text_5: "Custom",
    p_packages_text_6: "Set your own colors in the menu design.",
    p_packages_text_7: "color combinations",
    p_packages_text_8: "You can create users who have access to your account.",
    p_packages_text_9: "Sub-accounts",
    p_packages_text_10: "for colleagues, or employees",
    p_packages_text_11:
        "Add reviews of your clients, which will be part of the offer.",
    p_packages_text_12: "Reviews",
    p_packages_text_13: "of your clients in the offer",
    p_packages_text_14: "Offers",
    p_packages_text_15: "If you want, you can hide our logo in your offers.",
    p_packages_text_16: "without logo",
    p_packages_text_17: "DOFFERO",
    p_packages_text_18:
        "We offer PREMIUM users the option of customizing the appearance of the price offer.",
    p_packages_text_19: "Custom templtes",
    p_packages_text_20: "of the price offer",
    p_packages_text_21:
        "Possibility to switch the menu to English, German and Czech language",
    p_packages_text_22: "Ability to insert images to items",
    p_packages_text_23: "Possibility to upload",
    p_packages_text_24:
        "Upload documents or files that your customer can download in the online offer.",
    p_packages_text_25: "documents for uploads",
    p_packages_text_26:
        "Option to set different currencies - EUR, CZK, USD, GBP",
    p_packages_text_27:
        "Possibility to create price offers under different companies",
    p_packages_text_28: "Possibility to connect DOFFERO® to",
    p_packages_text_29: "SuperFaktura.sk",
    p_packages_text_30: "I want to register for free",
    p_packages_text_31: "Your current packet",
    p_packages_text_32:
        "DOFFERO is currently free with all features. There are no rugs.",
    p_packages_text_33: "and how about prices?",
    p_packages_text_34: "DOFFERO is",
    p_packages_text_35: "currently",
    p_packages_text_36: "free for everybody",

    register_text_1: "What can we offer you?", // This line corresponds to the commented-out subtitle
    register_text_2: "What will you like about DOFFERO price offers?",
    register_text_3: "Amazing design",
    register_text_4: "Beautiful",
    register_text_5: "design",
    register_text_6: "More new jobs",
    register_text_7: "Quick",
    register_text_8: "creation",
    register_text_9: "Refined templates",
    register_text_10: "Adjustable",
    register_text_11: "colors",
    register_text_12: "Approved with 1 click",
    register_text_13: "Approval",
    register_text_14: "for 1 click",
    register_text_15: "based on questionnaires from our users",
    register_text_16:
        "I used the app for about 10 offers and 7 of them were successful. We'll see how it goes. :)",
    register_text_17: "Matej, computer programmer",

    register_text_19: "You haven't tried our FREE price offers yet?",
    register_text_20: "Change it! Just register or",
    register_text_21: "log in",
    register_text_22: "Name and surname",
    register_text_23: "E-mail",
    register_text_24: "Password",
    register_text_25: "8 characters",
    register_text_26: "1 capital letter",
    register_text_27: "1 digit",
    register_text_28: "Create account",
    register_text_29: "Please read the",
    register_text_30: "Privacy policy",

    validation_text_1: "Name is a mandatory information.",
    validation_text_2: "E-mail is a neccesary detail.",
    validation_text_3: "Enter the correct e-mail format.",
    validation_text_4: "E-mail already exists.",
    validation_text_5: "Password is a necessary detail.",
    validation_text_6: "Password must contain more than 8 characters.",
    validation_text_7: "Password must contain more than 8 characters.",
    validation_text_8: "Company name is a mandatory information.",

    login_text_1: "Doffero",
    login_text_2: "Welcome back!",
    login_text_3: "Don't have an account yet?",
    login_text_4: "Register",
    login_text_5: "Forgot your password?",
    login_text_6: "Log in",
};
